import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  variant?: 'default' | 'accent' | 'ok' | 'muted';
  className?: string;
}

/** Mono, uppercase, square — a label rather than a pill. */
export function Badge({ children, variant = 'default', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-sm border px-2 py-0.5 font-mono text-[10.5px] font-medium uppercase tracking-label',
        variant === 'default' && 'border-line-strong text-ink-2 bg-paper-2',
        variant === 'accent' && 'border-accent/60 text-accent-ink bg-accent-soft',
        variant === 'ok' && 'border-ok/40 text-ok bg-ok/10',
        variant === 'muted' && 'border-line text-ink-4 bg-transparent',
        className
      )}
    >
      {children}
    </span>
  );
}
